import { action } from 'satcheljs';

export const observableNowChanged: () => {} = action('observableNowChanged');
export const observableTodayChanged: () => {} = action('observableTodayChanged');
